export enum UpsaleEnum {
  Included = 'W zakresie wybranego\xa0',
}
